import { useCallback, useEffect, useRef } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { IconButton, Tooltip } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { AddSignalForm } from '../AddSignal';

interface Props {
  strategyId: string;
  onClose: () => void;
  onApprove: () => void;
}

export function SignalDialog({ strategyId, onClose, onApprove }: Props) {
  const descriptionElementRef = useRef<HTMLElement>(null);
  const restartOnboardingRef = useRef<(() => void) | null>(null);

  useEffect(() => {
    const { current: descriptionElement } = descriptionElementRef;
    if (descriptionElement !== null) {
      descriptionElement.focus();
    }
  }, []);

  const handleRestartOnboarding = useCallback(() => {
    restartOnboardingRef.current?.();
  }, []);

  return (
    <Dialog
      open
      onClose={onClose}
      scroll="paper"
      maxWidth="xl"
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle id="scroll-dialog-title" align="center">
        Новый сигнал
      </DialogTitle>
      <Tooltip title="Запустить ознакомительный режим">
        <IconButton
          aria-label="Запустить ознакомительный режим"
          onClick={handleRestartOnboarding}
          tabIndex={0}
          sx={(theme) => ({
            position: 'absolute',
            left: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <HelpOutlineIcon />
        </IconButton>
      </Tooltip>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <DialogContentText id="scroll-dialog-description" ref={descriptionElementRef} tabIndex={-1}>
          <AddSignalForm
            strategyId={strategyId}
            onClose={onClose}
            onApprove={onApprove}
            onRestartRef={restartOnboardingRef}
          />
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
}
